import React from "react";
import { configureStore /*, getDefaultMiddleware */} from "@reduxjs/toolkit";
//import socketMiddleware from "middlewares";
import { rootReducer } from "reducers";

const PrefsContext = React.createContext();

const store = configureStore({
  reducer: rootReducer,
  //middleware: [...getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }), socketMiddleware]
});

export { store, PrefsContext };
